import { render, staticRenderFns } from "./FullScreenLayout.vue?vue&type=template&id=3e801b87&scoped=true"
import script from "./FullScreenLayout.vue?vue&type=script&lang=js"
export * from "./FullScreenLayout.vue?vue&type=script&lang=js"
import style0 from "./FullScreenLayout.vue?vue&type=style&index=0&id=3e801b87&prod&lang=css"
import style1 from "./FullScreenLayout.vue?vue&type=style&index=1&id=3e801b87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e801b87",
  null
  
)

export default component.exports